const STORAGE_KEY_PREFIX = "pendingInvitationsBannerSuppressedUntil";
const SUPPRESSION_MS = 24 * 60 * 60 * 1000;

const buildKey = (adminUserId: string, organizationId: string) =>
  `${STORAGE_KEY_PREFIX}:${adminUserId}:${organizationId}`;

export const suppressPendingInvitationsBanner = (
  adminUserId: string,
  organizationId: string,
  now: number = Date.now()
) => {
  try {
    globalThis.localStorage?.setItem(
      buildKey(adminUserId, organizationId),
      String(now + SUPPRESSION_MS)
    );
  } catch {
    return;
  }
};

export const isPendingInvitationsBannerSuppressed = (
  adminUserId: string,
  organizationId: string,
  now: number = Date.now()
) => {
  try {
    const stored = globalThis.localStorage?.getItem(
      buildKey(adminUserId, organizationId)
    );

    if (!stored) {
      return false;
    }

    const suppressedUntil = Number(stored);

    return Number.isFinite(suppressedUntil) && suppressedUntil > now;
  } catch {
    return false;
  }
};
